module.exports = window.crypto;


//////////////////
// WEBPACK FOOTER
// ./~/randomhex/src/browser.js
// module id = 485
// module chunks = 0